import React from "react";
import ListerLedger from "../lister/ListerLedger";

export default function IssuerLedger() {
    return <ListerLedger entityName="Issuer" apiPrefix="issuer" />;
}
